import React from "react"; 
import { HiOutlineViewList } from 'react-icons/hi'; 
import './style.css'; 
let PmcmAlligment=(props)=> { 
  return(
  <div>
    <nav class="navbar navbar-expand-lg py-3">
      <div class="container">
        <a href="#" class="navbar-brand">
          <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" /> <span className="text-uppercase font-weight-bold">Company</span>
        </a>
        <button id='navResponsiveButton' type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span className="navbar-toggler-icon"></span> 
          <HiOutlineViewList size={30} id='threebutt' />
        </button>
        <div id="navbarSupportedContent" className="collapse navbar-collapse">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active"><a href="#" className="nav-link"  onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Services</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >About </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" >Contact </a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link" id='cas-link'>Case Studies</a>
            </li>
            <li className="nav-item"><a href="#" className="nav-link"  onClick={()=>props.history.push('/signin')}      >Signin</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div id="centerME">
      <div className="boxStAc">
        <h4 id="h4">
  PMCM ScoreCard
  </h4>
        <br></br>
        <h6 id="h6">
  
  This score evalutes extent of alignment amonst product -market-channel & modal
  </h6>
        <div id='divL'>
          <table id='tableAll'>
            <thead>
              <tr>
                <th scope="col">Caragory</th>
                <th scope="col">Dimension</th>
                <th scope="col">Obtained Score</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td data-label="Caragory">Market- Channel</td>
                <td data-label="Dimension">Problem Score</td>
                <td data-label="Obtained Score">
                  <input type='text' placeholder="" id="lockedInput"></input>
                </td>
              </tr>
              <tr>
                <td data-label="Caragory">Market- Channel</td>
                <td data-label="Dimension">Problem validity Score</td>
                <td data-label="Obtained Score">
                  <input type='text' placeholder="" id="lockedInput"></input>
                </td>
              </tr>
              <tr>
                <td data-label="Caragory">Product model Market</td>
                <td data-label='Dimension'>business Goal</td>
                <td data-label="Obtained Score">
                  <select>
                    <option value="0">Combo Box:</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="Caragory">Channel</td>
                <td data-label='Dimension'>lorem t is a long established fact that a reader will be distracted by the readable content of a page when looking at its</td>
                <td data-label="Obtained Score">
                  <select>
                    <option value="0">Combo Box: Yes/no</option>
                    <option value="1">yes</option>
                    <option value="2">no</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td data-label="">Total</td>
                <td></td>
                <td data-label="Select Any On Option">
                  <input type='text' placeholder="Locked" id="lockedInput"></input>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="flexLef">
          <button className="button2" onClick={()=>props.history.push('/marketingScore')} id='BackNext'>Back</button>
          <button className="button2" onClick={()=>props.history.push('/demndPeak')} id='BackNext'>Next</button>
        </div>
      </div>
    </div>
  </div>) } 
  export default PmcmAlligment;